import { GenericBanner } from "@/components/GenericBanner";
import { JobSearchField } from "@/components/JobSearchField";

export default function Banner({ className }) {
  return (
    <GenericBanner
      className={className}
      title={{ path: "page.form.complete.banner.title", placeholder: "Thank <i>you</i>" }}
    >
      <JobSearchField />
    </GenericBanner>
  );
}